import React from "react";
import "./help.scss";

const HelpSearch = ({ isGuest, firstName }) => {
  const greeting = firstName ? `Hi, ${firstName}!` : "";
  const searchTitle = !isGuest ? greeting : "";

  return (
    <div className="help-search-wrapper">
      <h1 className="title1 mt-4">{searchTitle} How can we help?</h1>
    </div>
  );
};

export default HelpSearch;
